import React, { useEffect, useRef, useState } from "react";
import FsLightbox from "fslightbox-react";
import "../Quality/CustomerApproval.scss";
import { images } from "../../assets";
import { Breadcrumbs } from "@mui/material";
import { Link } from "react-router-dom";
import { textVariants } from "../../Header/Motion";
import { motion } from "framer-motion";
import Banner from "../../assets/Quality/customerapp.jpg";
import LocomotiveScroll from "locomotive-scroll";
import { useWindowSize } from "react-use";
import Footer from "../../Footer/Footer";
import PreLoader from "../../loader/preloader";
const imagesLoaded = require("imagesloaded");

export const CustomerApproval = () => {
  const scrollRef = useRef(null);
  const { width } = useWindowSize();

  const [toggler1, setToggler1] = useState(false);
  const [toggler2, setToggler2] = useState(false);
  const [toggler3, setToggler3] = useState(false);
  const [toggler4, setToggler4] = useState(false);
  const [toggler5, setToggler5] = useState(false);
  const [toggler6, setToggler6] = useState(false);
  const [toggler7, setToggler7] = useState(false);
  const [toggler8, setToggler8] = useState(false);
  const [toggler9, setToggler9] = useState(false);


  useEffect(() => {
    let scrollContainer = document.querySelector("[data-scroll-container]");
    const scroll = new LocomotiveScroll({
      el: scrollRef.current,
      smooth: true,
      getSpeed: true,
      getDirection: true,
      multiplier: 0.4, // Adjust the scroll speed here
    });

    scroll.update(); // Manually update the scroll height

    imagesLoaded(scrollContainer, { background: true }, function () {
      scroll.update();
    });
    const resizeObserver = new ResizeObserver((entries) => {
      scroll.update();
    });

    // start observing a DOM node
    resizeObserver.observe(document.body);

    return () => {
      resizeObserver.unobserve(document.body);
  
        scroll.destroy();
      }
      
  }, []);

  return (
    <>
      <PreLoader />
      <div
        className="customer_approval_container"
        ref={scrollRef}
        data-scroll-container
        style={{
          background: "#141414",
          backgroundImage: `url(${Banner})`,
          backgroundSize: width > 600 ? "cover" : "contain",
          overflow: "hidden",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
        }}
      >
        <section
          id="scrolltop"
          className="CustomerApproval_sec1"
          style={{
            overflow: "hidden",
          }}
          data-scroll-section
        >
          <div
            className="certification_bg"
          // style={{ backgroundImage: `url(${Banner})` }}
          >
            <div className="certification_breadcrumbs ">
              <Breadcrumbs separator=">" aria-label="breadcrumb">
                <Link to="/">
                  <img
                    src={images.homeicon.image}
                    alt={images.homeicon.alt}
                    loading="lazy"
                    width={20}
                  />{" "}
                </Link>
                <Link to="/quality-overview">QUALITY</Link>
                <Link to="/customer-approval">VENDOR APPROVAL</Link>
              </Breadcrumbs>
            </div>
            <div className="customer-heading">
              <motion.h2
                variants={textVariants("up", 0.2, 2.5)}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, amount: 0.1 }}
                transition={{ duration: 0.5 }}
              >
                VENDOR APPROVAL
              </motion.h2>
            </div>
            <div className="scroll-down-d" style={{ zIndex: "5" }}>
              <div className="spinner scroll-down">
                {" "}
                <a
                  style={{ cursor: "pointer" }}
                  href="#vendor"
                  data-scroll-to
                  className="animate"
                ></a>{" "}
              </div>
            </div>
          </div>
        </section>

        <section
          id="vendor"
          className="CustomerApproval_sec2"
          style={{ background: "var(--bg-white-color)", height: "100%", overflow: "hidden" }}
          data-scroll-section
        >
          <div className="quality-assurance-section">
            {/* <motion.div
              variants={textVariants("up", 0.2)}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.1 }}
              transition={{ duration: 0.5 }}
            > */}
            <h2>VENDOR APPROVAL</h2>
            {/* </motion.div> */}
            <div>
              <motion.p
                variants={textVariants("up", 0.2)}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, amount: 0.1 }}
                transition={{ duration: 0.5 }}
              >
                We are honored to have earned vendor approval from renowned
                industry leaders at Multimetals. Our valued partnerships with
                esteemed organizations such as Petrobras, Abu Dhabi Marine
                Operating Company, Samsung, Kuwait National Petroleum Company,
                Saudi Aramco and Sabic exemplify our unwavering dedication to
                upholding stringent quality standards and adhering to rigorous
                quality control protocols.
                <br />
              </motion.p>
              <motion.p
                variants={textVariants("up", 0.2)}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, amount: 0.1 }}
                transition={{ duration: 0.5 }}
              >
                Being a vendor to these renowned companies is not only an honor
                but also a testament to our unwavering dedication to provide
                eminent quality. By aligning our practices with their quality
                standards and adhering to their strict QC protocols, we have
                established ourselves as a trusted partner in the industry.{" "}
                <br />
              </motion.p>
              <motion.p
                variants={textVariants("up", 0.2)}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, amount: 0.1 }}
                transition={{ duration: 0.5 }}
              >
                Our commitment to reliability, consistency, and customer
                satisfaction sets us apart and ensures that we consistently meet
                the expectations of our esteemed clients. Being their trusted
                partner is a sign of our capabilities and expertise, and we look
                forward to further strengthening these relationships as we work
                together to achieve mutual success.
              </motion.p>
            </div>

            <div className="row certificate_row approval_row">
              <div className="col-6 col-sm-6 col-md-4 p-0">
                <motion.div
                  variants={textVariants("up", 0.2)}
                  initial="hidden"
                  whileInView="show"
                  viewport={{ once: true, amount: 0.1 }}
                  transition={{ duration: 0.5 }}
                >
                  <div className="application_box">
                    <img
                      src={images.vendor1.image}
                      alt=""
                      style={{
                        width: "100%",
                        maxWidth: "",
                        height: "100%",
                        maxHeight: "375px",
                      }}
                      onClick={() => setToggler1(!toggler1)}
                    />
                  </div>

                </motion.div>
              </div>
              <div className="col-6 col-sm-6 col-md-4 p-0">
                <motion.div
                  variants={textVariants("up", 0.2)}
                  initial="hidden"
                  whileInView="show"
                  viewport={{ once: true, amount: 0.1 }}
                  transition={{ duration: 0.5 }}
                >
                  <div className="application_box">
                    <img
                      src={images.vendor3.image}
                      alt=""
                      style={{
                        width: "100%",
                        maxWidth: "",
                        height: "100%",
                        maxHeight: "375px",
                      }}
                      onClick={() => setToggler2(!toggler2)}
                    />
                  </div>

                </motion.div>
              </div>
              <div className="col-6 col-sm-6 col-md-4 p-0">
                <motion.div
                  variants={textVariants("up", 0.2)}
                  initial="hidden"
                  whileInView="show"
                  viewport={{ once: true, amount: 0.1 }}
                  transition={{ duration: 0.5 }}
                >
                  <div className="application_box">
                    <img
                      src={images.vendor4.image}
                      alt=""
                      style={{
                        width: "100%",
                        maxWidth: "",
                        height: "100%",
                        maxHeight: "375px",
                      }}
                      onClick={() => setToggler3(!toggler3)}
                    />
                  </div>

                </motion.div>
              </div>
              <div className="col-6 col-sm-6 col-md-4 p-0">
                <motion.div
                  variants={textVariants("up", 0.2)}
                  initial="hidden"
                  whileInView="show"
                  viewport={{ once: true, amount: 0.1 }}
                  transition={{ duration: 0.5 }}
                >
                  <div className="application_box">
                    <img
                      src={images.vendor7.image}
                      alt=""
                      style={{
                        width: "100%",
                        maxWidth: "",
                        height: "100%",
                        maxHeight: "375px",
                      }}
                      onClick={() => setToggler4(!toggler4)}
                    />
                  </div>

                </motion.div>
              </div>
              <div className="col-6 col-sm-6 col-md-4 p-0">
                <motion.div
                  variants={textVariants("up", 0.2)}
                  initial="hidden"
                  whileInView="show"
                  viewport={{ once: true, amount: 0.1 }}
                  transition={{ duration: 0.5 }}
                >
                  <div className="application_box">
                    <img
                      src={images.vendor8.image}
                      alt=""
                      style={{
                        width: "100%",
                        maxWidth: "",
                        height: "100%",
                        maxHeight: "375px",
                      }}
                      onClick={() => setToggler5(!toggler5)}
                    />
                  </div>

                </motion.div>
              </div>
              <div className="col-6 col-sm-6 col-md-4 p-0">
                <motion.div
                  variants={textVariants("up", 0.2)}
                  initial="hidden"
                  whileInView="show"
                  viewport={{ once: true, amount: 0.1 }}
                  transition={{ duration: 0.5 }}
                >
                  <div className="application_box">
                    <img
                      src={images.vendor9.image}
                      alt=""
                      style={{
                        width: "100%",
                        maxWidth: "",
                        height: "100%",
                        maxHeight: "375px",
                      }}
                      onClick={() => setToggler6(!toggler6)}
                    />
                  </div>

                </motion.div>
              </div>
              <div className="col-6 col-sm-6 col-md-4 p-0">
                <motion.div
                  variants={textVariants("up", 0.2)}
                  initial="hidden"
                  whileInView="show"
                  viewport={{ once: true, amount: 0.1 }}
                  transition={{ duration: 0.5 }}
                >
                  <div className="application_box">
                    <img
                      src={images.vendor10.image}
                      alt=""
                      style={{
                        width: "100%",
                        maxWidth: "",
                        height: "100%",
                        maxHeight: "375px",
                      }}
                      onClick={() => setToggler7(!toggler7)}
                    />
                  </div>

                </motion.div>
              </div>
              <div className="col-6 col-sm-6 col-md-4 p-0">
                <motion.div
                  variants={textVariants("up", 0.2)}
                  initial="hidden"
                  whileInView="show"
                  viewport={{ once: true, amount: 0.1 }}
                  transition={{ duration: 0.5 }}
                >
                  <div className="application_box">
                    <img
                      src={images.vendor11.image}
                      alt=""
                      style={{
                        width: "100%",
                        maxWidth: "",
                        height: "100%",
                        maxHeight: "375px",
                      }}
                      onClick={() => setToggler8(!toggler8)}
                    />
                  </div>

                </motion.div>
              </div>
              <div className="col-6 col-sm-6 col-md-4 p-0">
                <motion.div
                  variants={textVariants("up", 0.2)}
                  initial="hidden"
                  whileInView="show"
                  viewport={{ once: true, amount: 0.1 }}
                  transition={{ duration: 0.5 }}
                >
                  <div className="application_box">
                    <img
                      src={images.vendor12.image}
                      alt=""
                      style={{
                        width: "100%",
                        maxWidth: "",
                        height: "100%",
                        maxHeight: "375px",
                      }}
                      onClick={() => setToggler9(!toggler9)}
                    />
                  </div>

                </motion.div>
              </div>
            </div>
          </div>
        </section>
        <section
          className="footer_area"
          data-scroll-section
          style={{
            overflowY: "hidden",
          }}
        >
          <Footer />
        </section>
      </div>

      <FsLightbox
        toggler={toggler1}
        sources={[
          images.vendor1.image,
          images.vendor2.image,
        ]}
      />
      <FsLightbox
        toggler={toggler2}
        sources={[
          images.vendor3.image,
        ]}
      />
      <FsLightbox
        toggler={toggler3}
        sources={[
          images.vendor4.image,
          images.vendor5.image,
          images.vendor6.image,
        ]}
      />
      <FsLightbox
        toggler={toggler4}
        sources={[
          images.vendor7.image,
        ]}
      />
      <FsLightbox
        toggler={toggler5}
        sources={[
          images.vendor8.image,
        ]}
      />
      <FsLightbox
        toggler={toggler6}
        sources={[
          images.vendor9.image,
        ]}
      />
      <FsLightbox
        toggler={toggler7}
        sources={[
          images.vendor10.image,
        ]}
      />
      <FsLightbox
        toggler={toggler8}
        sources={[
          images.vendor11.image,
        ]}
      />
      <FsLightbox
        toggler={toggler9}
        sources={[
          images.vendor12.image,
        ]}
      />
    </>
  );
};
